<template>
  <div class="keys" v-show="showNoBoard" ref="keyboard" @click.self="close">
	<slot></slot>
    <div :class="showNoBoard ? 'prolist show' : 'prolist'">
      <div class="buttons" v-if="showTitleBtn">
        <div @click="close">取消</div>
        <div @click="confirm">确认</div>
      </div>

      <div class="specChars">
        <div :key="index" v-for="(item, index) in speChars" @click="handleChoose($event, item)">{{item}}</div>
      </div>

      <div class="numbers">
        <div v-for="(item, index) in numbers" :key="index" @click="handleChoose($event, item)">{{item}}</div>
      </div>

      <div class="chars">
        <div :key="index" v-for="(item, index) in chars" @click="handleChoose($event, item)">{{item}}</div>
        <div class="delete" @click="del">删除</div>
      </div>
    </div>
    <!-- <Tip ref="tip" /> -->
  </div>
</template>

<script>

export default {
  data() {
    return {
      carNo: '',
      speChars: ['港', '澳', '学', '警', '领'],
      numbers: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      chars: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    }
  },
  props: {
    showTitleBtn: {
      type: Boolean,
      default: false
    },
    showNoBoard: {
      type: Boolean
    },
    chooseCarNO: {
      type: Function
    },
    delect: {
      type: Function
    },
    province: {
      type: String
    },
    getCarNo: {
      type: Function
    }
  },
  mounted() {
    const fwrap = this.$refs.keyboard.parentNode.parentNode.parentNode
    fwrap.appendChild(this.$refs.keyboard)
  },
  methods: {
    close() {
      this.$emit('closeCarNO')
    },
    confirm() {
      if (!/^[A-Z][a-zA-Z0-9]{4,5}[a-zA-Z0-9挂学警港澳]$/.test(this.carNo)) {
        tuhu.toast('请输入正确的车牌号')
      } else {
        this.close()
      }
    },
    handleChoose(ev, item) {
      $(ev['target']).addClass('transShadow')
      setTimeout(() => {
        $(ev['target']).removeClass('transShadow')
      }, 100)

      if (this.carNo.length > 6) {
        tuhu.toast('请输入正确的车牌号')
        return
      }

      this.carNo = this.carNo + item

      this.chooseCarNO(this.carNo)
      // this.getCarNo(this.province + this.carNo)
    },
    del() {
      this.carNo = this.carNo.slice(0, -1)
      this.delect()
    }
  }
}
</script>

<style src="../css/keyboard.css" scoped></style>



// WEBPACK FOOTER //
// src/components/platen.vue